(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    /*
  Keksshop: Formular "Vereine & Firmen" geht an Shopify (Mail an die Shop-Absenderadresse)
  UND zusätzlich per fetch an den eigenen Upload-Dienst (/anfrage), der an business@cookiehaus.de
  weiterleitet. Ohne wartende Antwort (keepalive), damit das normale Shopify-Formular sofort danach
  abgeht. Nur aktiv, wenn die Einstellung "Adresse des Upload-Dienstes" gesetzt ist.
*/
(() => {
  function keksAnfrageBetreffAktualisieren(formular) {
    const betreffFeld = formular.querySelector('[data-keks-anfrage-betreff]');
    if (!betreffFeld) return;
    const artFeld = formular.querySelector('[data-keks-anfrageart-feld]');
    const art = artFeld ? artFeld.value.trim() : '';
    betreffFeld.value = art ? `Vereine & Firmen: ${art}` : 'Vereine & Firmen';
  }

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-keks-anfrageart-feld]')) return;
    const formular = event.target.closest('form');
    if (formular) keksAnfrageBetreffAktualisieren(formular);
  });

  // Bewusst in der Bubble-Phase (Standard): Ist ein Datei-Upload noch nicht fertig, blockiert
  // keks-shop.js das Absenden schon in der Capture-Phase, dann kommt dieser Listener gar nicht dran.
  document.addEventListener('submit', (event) => {
    const formular = event.target;
    if (!(formular instanceof HTMLFormElement)) return;
    const wrapper = formular.closest('[data-keks-anfrage-melden]');
    if (!wrapper) return;

    keksAnfrageBetreffAktualisieren(formular);

    const basis = String(wrapper.dataset.keksAnfrageUrl || '').replace(/\/+$/, '');
    if (!basis) return;

    const daten = new FormData(formular);
    const nutzlast = {
      quelle: wrapper.dataset.keksAnfrageQuelle || 'vereine-firmen',
      name: String(daten.get('contact[name]') || ''),
      email: String(daten.get('contact[email]') || ''),
      nachricht: String(daten.get('contact[body]') || ''),
    };
    const artFeld = formular.querySelector('[data-keks-anfrageart-feld]');
    if (artFeld && artFeld.value) nutzlast.anfrageart = artFeld.value;
    const stueckzahlFeld = formular.querySelector('[data-keks-stueckzahl-feld]');
    if (stueckzahlFeld && stueckzahlFeld.value) nutzlast.stueckzahl = stueckzahlFeld.value;
    const terminFeld = formular.querySelector('[data-keks-termin-feld]');
    if (terminFeld && terminFeld.value) nutzlast.gebraucht_bis = terminFeld.value;
    const dateiFeld = formular.querySelector('keks-upload [data-link]');
    if (dateiFeld && dateiFeld.value) nutzlast.datei_url = dateiFeld.value;

    try {
      fetch(`${basis}/anfrage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nutzlast),
        keepalive: true,
      }).catch(() => {});
    } catch (fehler) {
      /* Die Antwort wird nie abgewartet: Shopify bekommt das Formular so oder so. */
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
